import { Component, ElementRef, Optional, ViewChild } from '@angular/core';
import { RequestServiceService } from './core/services/request-service/request-service.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Messaging, getMessaging, getToken, onMessage } from '@angular/fire/messaging';
import { EMPTY, from, Observable } from 'rxjs';
import { share, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Message } from './core/constants/message';
import { MessagesService } from './core/services/messages/messages.service';
import { MatDialog } from '@angular/material/dialog';
import { NotificationDialogComponent } from './notification-dialog/notification-dialog.component';
import { onBackgroundMessage } from "firebase/messaging/sw";
import { key } from './core/constants/key';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  resId: any;
  title(title: any) {
    throw new Error('Method not implemented.');
  }
  // Check if the browser supports the beforeinstallprompt event
  deferredPrompt: any;
  serviceWorkerSupported: boolean = 'serviceWorker' in navigator;
  serviceWorkerRegistered: boolean = false;
  @ViewChild('myModal')
  myModal!: ElementRef;
  @ViewChild('myModal1')
  myModal1!: ElementRef;
  
  request() {
    Notification.requestPermission();
  }
  addFCMTokenCalled: boolean = false;

  token$: Observable<any> = EMPTY;
  message$: Observable<any> = EMPTY;

  constructor(public messageservices: MessagesService, @Optional() messaging: Messaging, public router: Router, private requestApiService: RequestServiceService, private route: ActivatedRoute, private modalService: NgbModal, public dialog: MatDialog) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) { // Check if the event is a NavigationEnd event
        // Execute the constructor logic here
        console.log(event, "bh")
        if (localStorage.getItem('force_update_pass') == '1') {
          this.router.navigate(['/force-update-password']);
        }
        if (localStorage.getItem("userData")) {
          this.resId = localStorage.getItem(key.RES_UID) ;
          this.token$ = from(
            navigator.serviceWorker.register('assets/js/firebase-messaging-sw.js', { type: 'module', scope: 'assets/js/__' }).
              then(serviceWorkerRegistration =>
                getToken(messaging, {
                  serviceWorkerRegistration,
                  vapidKey: environment.vapidKey,
                })
              )).pipe(
                tap(token => {
                  if (token.indexOf(':') != -1 ) {
                    this.addFCMTokenCalled = true; 
                    console.log({ token })
                    this.subscribeTokenToTopic(token, this.resId+"_topic")
                    this.requestApiService.addFCMToken({ fcm_token: token }).then(apiResponseData => {
                      if (!apiResponseData.success) {
                        console.log("FCM token couldn't update");
                      }
                    });
                  }
                  
                }),
                share(),
                
              );
           
          this.message$ = new Observable(sub => onMessage(messaging, it => sub.next(it))).pipe(
            tap(token => {
           
              console.log('FCM', { token })
              console.log(token.data)

              if (token?.data && token?.data.type == 'booking' && event.url !== '/booking-list') {
                this.messageservices.showNotification(token?.data.message, Message.SUCCESS, Message.SUCCESS);
                this.playNotificationSound()
                const dialogRef = this.dialog.open(NotificationDialogComponent, {
                  width: '400px',
                  data: token?.data
                });

                dialogRef.afterClosed().toPromise().then(result => {
                  if (result === true) {

                    this.router.navigate([`/booking-list`]);


                  } else {

                  }
                });


              } else {
                this.messageservices.showNotification(token?.data.message, Message.SUCCESS, Message.SUCCESS);
                this.playNotificationSound()
                this.requestApiService.requestReload();
              }
            }),
          );
         
        }


      }
    });
    
  }
  onNavigationEnd() {

  }
   subscribeTokenToTopic(token:any, topic:any) {
    fetch('https://iid.googleapis.com/iid/v1/'+token+'/rel/topics/'+topic, {
      method: 'POST',
      headers: new Headers({
        'Authorization': 'key='+environment.fcm_server_key
      })
    }).then(response => {
      if (response.status < 200 || response.status >= 400) {
        throw 'Error subscribing to topic: '+response.status + ' - ' + response.text();
      }
      console.log('Subscribed to "'+topic+'"');
    }).catch(error => {
      console.error(error);
    })
  }
  playNotificationSound() {
    const audio = new Audio();
    audio.src = "/assets/notification.mp3";
    audio.load();
    audio.play();
    setTimeout(() => {
      audio.pause();
      audio.currentTime = 0;
    }, 10000);
  }
  ngOnInit() {
    if (localStorage.getItem('res_uid')) {
      this.requestApiService.setRestaurantInfoSubmitted(true);
    }
    if (this.serviceWorkerSupported) {
      navigator.serviceWorker.getRegistration().then((registration) => {
        if (registration) {
          this.serviceWorkerRegistered = true;
        }
      });
    }


    // Check if the browser supports the beforeinstallprompt event
    window.addEventListener('beforeinstallprompt', (e) => {
      // Prevent the default browser prompt
      e.preventDefault();
      // Store the event for later use
      this.deferredPrompt = e;
      // Show your custom install button or prompt here
      // You can make it visible on the page or customize its appearance
    });
  }

  // Trigger the custom installation prompt
  installPWA() {

    if (this.deferredPrompt) {
      // Show your custom button or prompt
      this.deferredPrompt.prompt();

      // Wait for the user to respond to the prompt
      this.deferredPrompt.userChoice
        .then((choiceResult: any) => {
          if (choiceResult.outcome === 'accepted') {

          } else {

          }
          // Reset the deferredPrompt
          this.deferredPrompt = null;
        });
    }
  }

  openModal(element: any) {
    this.modalService.open(this.myModal, { backdrop: 'static', keyboard: false ,centered: true});
  }
  openModal1(element: any) {
    this.modalService.open(this.myModal1, { backdrop: 'static', keyboard: false ,centered: true});
  }
}


